var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.canWrite
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-6 mx-auto" },
              [
                _c("bootstrap-box", {
                  staticClass: "text-center",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function() {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { to: "/Newsroom/Create" }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.resource("Newsroom_Index_NewItem_Btn")
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    672405464
                  )
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("remote-newsroom-item-list", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var newsroomItems = ref.newsroomItems
              return _vm._l(newsroomItems, function(newsroomItem) {
                return _c("newsroom-item-display", {
                  key: newsroomItem.id,
                  attrs: {
                    title: newsroomItem.title,
                    content: newsroomItem.content,
                    date: newsroomItem.date,
                    id: newsroomItem.id
                  }
                })
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }